import context from '@/context'
import getComponentKey from '@/utils/getComponentKey'
import commonErrorHandler from '@/utils/errors'

export const initialState = {
  institutionGroup: null,
  fetching: true,
  updating: false,
  componentKey: getComponentKey(),
  gridKey: getComponentKey()
}

export const actionTypes = {
  Fetching: 'institutionGroup/fetching',
  Fetched: 'institutionGroup/fetched',

  Updating: 'institutionGroup/updating',
  Updated: 'institutionGroup/updated',

  Error: 'institutionGroup/error'
}

const handleError = (details) => commonErrorHandler(actionTypes.Error, details)

export const actionCreators = {
  getById: (id) => (dispatch, getState) => {
    dispatch({ type: actionTypes.Fetching })

    context.api.institutionGroupService.getById(id)
      .then(response => {
        dispatch({ type: actionTypes.Fetched, data: response })
      })
      .catch(error => handleError({ dispatch, error, update: { fetching: false } }))
  },

  createNew: () => (dispatch, getState) => {
    dispatch({ type: actionTypes.Fetched, data: { id: 0, name: '', latinName: '', members: [] } })
  },
  addOrUpdate: (dto, callback) => (dispatch, getState) => {
    dispatch({ type: actionTypes.Updating })

    context.api.institutionGroupService.addOrUpdate(dto)
      .then((response) => {
        dispatch({ type: actionTypes.Updated })
        if (typeof callback === 'function') { callback() }
      })
      .catch(error => handleError({ dispatch, error, update: { updating: false } }))
  }
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.Fetching: return { ...state, fetching: true }
    case actionTypes.Fetched: return { ...state, fetching: false, institutionGroup: action.data, componentKey: getComponentKey() }
    case actionTypes.Updating: return { ...state, updating: true }
    case actionTypes.Updated: return { ...state, updating: false, gridKey: getComponentKey() }
    case actionTypes.Error: return { ...state, ...action.data }
    default: return state
  }
}



// WEBPACK FOOTER //
// ./src/store/InstitutionGroups.js